module.exports = __webpack_public_path__ + "img/banner_3.3a73dd1f.jpg";